import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250
		}
	}
};

function CampaignDropDown({
	adData,
	getFocusCampaign,
	theFocusCampaign,
	theFocusRegion
}) {
	const [focusCampaign, setFocusCampaign] = React.useState(theFocusCampaign);
	const [allCampaigns, setAllCampaigns] = React.useState([]);
	// const [isFirstLoad, setIsFirstLoad] = React.useState(true);

	//remove dupliates

	//create useEffect to set allCampaigns
	React.useEffect(() => {
		var campaigns = [];
		adData.map((ad) => {
			if (ad.region == theFocusRegion) {
				campaigns.push(ad.campaign);
			}
		});
		campaigns = [...new Set(campaigns)];
		setAllCampaigns(campaigns);
		setFocusCampaign(theFocusCampaign);
	}, [theFocusRegion]);

	// setAllCampaigns(campaigns);
	// console.log(campaigns);

	const handleChange = (event) => {
		//console.log(event.target.value);
		//send event.target.value to app.js
		getFocusCampaign(event.target.value);
		const {
			target: { value }
		} = event;
		setFocusCampaign(
			// On autofill we get a stringified value.
			typeof value === "string" ? value.split(",") : value
		);
	};

	return (
		<div>
			<FormControl sx={{ m: 1, width: 300 }}>
				<InputLabel id="demo-multiple-checkbox-label">Campaign</InputLabel>
				<Select
					labelId="demo-multiple-checkbox-label"
					id="demo-multiple-checkbox"
					single="true"
					value={focusCampaign ? focusCampaign : ""}
					onChange={handleChange}
					input={<OutlinedInput label="Campaign" />}
					renderValue={(selected) => selected}
					MenuProps={MenuProps}
				>
					{allCampaigns.map((campaign) => (
						<MenuItem key={campaign} value={campaign}>
							<Checkbox checked={focusCampaign == campaign} />
							<ListItemText primary={campaign} />
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</div>
	);
}
export default CampaignDropDown;
